import {Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {LanguageControllerService} from "../../services/language-controller/language-controller.service";
import {Store} from "../../services/store.service";
import {Language} from "../../models/language";
import {TranslatedBaseError} from "../pages/TranslatedBaseError";
import {ToastrService} from "ngx-toastr";
import {environment} from "../../../environments/environment";
import {TranslationsComponent} from "../pages/translations/translations.component";
import {
  PreviewTranslationsControllerService
} from "../../services/preview-translations-controller/preview-translations-controller.service";
import {GeneralTranslation} from "../../models/general-translation";

@Component({
  selector: "formio-translate",
  templateUrl: "./formio-translate.component.html",
  styleUrls: ["./formio-translate.component.scss"],
  providers: [PreviewTranslationsControllerService],
})
export class FormioTranslateComponent extends TranslatedBaseError implements OnInit {

  public serviceId: string;
  public componentKey: string;
  public formType: string;
  public formId: string;
  public languages: Language[];
  public myTranslations: any;

  public isTableBodyVisible = false;

  constructor(private route: ActivatedRoute, public store: Store,
              public translateService: TranslateService,
              private languageService: LanguageControllerService,
              private previewTranslationController: PreviewTranslationsControllerService,
              toastr: ToastrService) {
    super(toastr, translateService);

    translateService.setDefaultLang(store.state.common.lang);
    languageService.getLanguages().subscribe(
      (data) => {
        translateService.addLangs(data.map((l) => l.code));
      });
  }

  public ngOnInit() {
    this.loadLanguages();
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.store.state.common.serviceId = params.serviceId;
    });
    this.route.queryParamMap.subscribe((queryParams) => {
      this.componentKey = queryParams.get("key");
      this.formType = queryParams.get("formType");
      this.formId = queryParams.get("formId");
      this.loadTranslations();
    });
  }

  public loadLanguages() {
    this.languageService.getLanguages().subscribe(
      (data) => {
        this.languages = data;
      },
      (error) => this.showErrorMessageWithTitle("Error with language loading:" + " ", error),
    );
  }

  public loadTranslations() {
    this.isTableBodyVisible = false;
    this.myTranslations = [];
    let formType = "";
    switch (this.formType) {
      case "applicantform":
        formType = "Applicant form";
        break;
      case "guide":
        formType = "Guide";
        break;
      case "document-form":
        formType = "Document form";
        break;
      case "payment":
        formType = "Payment page";
        break;
      case "sendfile":
        formType = "Send file page";
        break;
      case "Role":
        formType = "FORM_ROLE";
        break;
      case "certificate-form":
        formType = "Template";
        break;
    }
    const form = {
      type: formType, id: this.formId
    };
    this.previewTranslationController.getServiceComponentTranslations(this.serviceId, this.componentKey, form).subscribe(
        (data) => {
          this.myTranslations = data;
          this.isTableBodyVisible = true;
          TranslationsComponent.updateTextareasHeight();
        },
        (error) => this.showErrorMessage(error),
      );
  }

  public saveTranslation(translation: GeneralTranslation) {
    this.previewTranslationController.saveTranslation(this.serviceId, translation).subscribe(
      (data) => {
        translation.id = data.id;
        this.responseSuccessful("Translations saved!");
      },
    );
  }

}
